import { render, staticRenderFns } from "./mybankPayRefundDetail.vue?vue&type=template&id=01b6b6e0&scoped=true"
import script from "./mybankPayRefundDetail.vue?vue&type=script&lang=js"
export * from "./mybankPayRefundDetail.vue?vue&type=script&lang=js"
import style0 from "./mybankPayRefundDetail.vue?vue&type=style&index=0&id=01b6b6e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b6b6e0",
  null
  
)

export default component.exports